/**
 * 获取查询字符串，并转换为key=>value对象
 *
 * @return {Object} 查询字符串的对象
 */
function getQueryString() {
  let pathName = decodeURIComponent(location.search)
  const obj = {}
  if (!pathName) {
    return obj
  }
  // 查询字符串
  pathName = pathName.substring(1)
  // 转换为对象
  const searArr = pathName.split('&')
  searArr.forEach(item => {
    let index = item.indexOf('=')
    const arr = item.split('=')
    // obj[arr[0]] = arr[1]
    obj[arr[0]] = item.substring(index + 1)
  })
  return obj
}

/**
 * 获取某个查询字符串的值
 *
 * @param {string} key 查询字符串的key
 * @return {string} key对应的查询字符串的value
 */

function getQueryofKey(key) {
  if (key == null) {
    return
  }
  return getQueryString()[key]
}
export { getQueryString, getQueryofKey }
